var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActionRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18-Domain-pending",
    transform: "translate(-420.000000, -11.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(420.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-action-required"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3,
    transform: "translate(0.750000, 0.750000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.75,
    cy: 6.75,
    r: 6.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,11.25 L6.75,11.25 L6.75,6.75 L8.25,6.75 L8.25,11.25 Z M8.25,5.25 L6.75,5.25 L6.75,3.75 L8.25,3.75 L8.25,5.25 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15 C3.375,15 0,11.625 0,7.5 C0,3.375 3.375,0 7.5,0 C11.625,0 15,3.375 15,7.5 C15,11.625 11.625,15 7.5,15 Z M7.5,1.5 C4.2,1.5 1.5,4.2 1.5,7.5 C1.5,10.8 4.2,13.5 7.5,13.5 C10.8,13.5 13.5,10.8 13.5,7.5 C13.5,4.2 10.8,1.5 7.5,1.5 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionRequired);
export default __webpack_public_path__ + "static/media/icon-action-required.19ea78fa0f907361d1ba85ce4fee50b2.svg";
export { ForwardRef as ReactComponent };